(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sections = document.querySelectorAll('[data-willian-scroll-slogan]');

  const readRgb = (value) => {
    const probe = document.createElement('span');
    probe.style.color = value;
    document.body.appendChild(probe);
    const rgb = getComputedStyle(probe).color.match(/\d+/g).slice(0, 3).map(Number);
    probe.remove();
    return rgb;
  };

  const mix = (a, b, progress) => Math.round(a + (b - a) * progress);
  const color = (a, b, progress) => `rgb(${mix(a[0], b[0], progress)}, ${mix(a[1], b[1], progress)}, ${mix(a[2], b[2], progress)})`;

  sections.forEach((section) => {
    const pin = section.querySelector('.willian-scroll-slogan__pin');
    const shade = section.querySelector('.willian-scroll-slogan__shade');
    const text = section.querySelector('.willian-scroll-slogan__text');
    const lines = section.querySelectorAll('.willian-scroll-slogan__line');
    const supporting = section.querySelector('.willian-scroll-slogan__supporting');
    const desktopPhoto = section.querySelector('.willian-scroll-slogan__photo--desktop');
    const mobilePhoto = section.querySelector('.willian-scroll-slogan__photo--mobile');
    const settleProgress = Number(section.dataset.settleProgress || 0.68);
    const darkProgress = Number(section.dataset.darkProgress || 0.62);
    const styles = getComputedStyle(section.closest('.shopify-section') || section);
    const startBg = readRgb(styles.getPropertyValue('--willian-slogan-bg').trim() || '#f3f0ea');
    const endBg = readRgb(styles.getPropertyValue('--willian-slogan-invert-bg').trim() || '#020202');
    const startText = readRgb(styles.getPropertyValue('--willian-slogan-text').trim() || '#2d251d');
    const endText = readRgb(styles.getPropertyValue('--willian-slogan-invert-text').trim() || '#f3f0ea');
    const chars = [];

    lines.forEach((line) => {
      const originalText = line.textContent;
      line.innerHTML = '';

      [...originalText].forEach((character) => {
        const char = document.createElement('span');
        const number = chars.length + 1;

        char.className = 'willian-scroll-slogan__char';
        char.innerHTML = character === ' ' ? '&nbsp;' : character;
        char.dataset.x = Math.sin(number * 12.7) * 170;
        char.dataset.y = Math.cos(number * 8.3) * 120;
        char.dataset.r = Math.sin(number * 5.1) * 20;

        line.appendChild(char);
        chars.push(char);
      });
    });

    const update = () => {
      if (reduceMotion) return;

      const rect = section.getBoundingClientRect();
      const max = Math.max(1, section.offsetHeight - window.innerHeight);
      const progress = Math.min(1, Math.max(0, -rect.top / max));
      const settle = Math.min(1, progress / settleProgress);
      const ease = 1 - Math.pow(1 - settle, 3);

      chars.forEach((char) => {
        const x = Number(char.dataset.x) * (1 - ease);
        const y = Number(char.dataset.y) * (1 - ease);
        const rotation = Number(char.dataset.r) * (1 - ease);

        char.style.transform = `translate(${x}px, ${y}px) rotate(${rotation}deg)`;
      });

      const dark = Math.min(1, Math.max(0, (progress - darkProgress) / (1 - darkProgress)));
      const backgroundStart = 0.55;
      const backgroundEnd = 0.74;
      const backgroundProgress = Math.min(1, Math.max(0, (progress - backgroundStart) / (backgroundEnd - backgroundStart)));
      const textDarkProgress = backgroundProgress;
      const supportStart = 0.68;
      const supportEnd = 0.82;
      const supportProgress = Math.min(1, Math.max(0, (progress - supportStart) / (supportEnd - supportStart)));
      const supportEase = 1 - Math.pow(1 - supportProgress, 3);
      const photoStart = 0.7;
      const photoEnd = 0.84;
      const photoProgress = Math.min(1, Math.max(0, (progress - photoStart) / (photoEnd - photoStart)));
      const photoEase = 1 - Math.pow(1 - photoProgress, 3);

      shade.style.opacity = dark;
      pin.style.background = color(startBg, endBg, backgroundProgress);
      text.style.color = color(startText, endText, textDarkProgress);

      if (supporting) {
        supporting.style.opacity = supportEase;
        supporting.style.transform = `translateY(${8 * (1 - supportEase)}px)`;
      }

      if (desktopPhoto) {
        desktopPhoto.style.opacity = photoEase;
      }

      if (mobilePhoto) {
        mobilePhoto.style.opacity = photoEase;
      }
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
